import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './screens/Homepage';
import LoginPage from './screens/Loginpage';
import ProtectedPage from './screens/Protectedpage';
import PrivateRoute from './screens/Privateroute';
import { AuthProvider, useAuth } from './context/AuthProvider';
import ClientScreen from './screens/ClientScreen';
import MyResults from './screens/MyResults';
import './styles/body.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<RequireAuth><HomePage /></RequireAuth>} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/protected" element={<PrivateRoute><ProtectedPage/></PrivateRoute>}/>
                    <Route path="/protected/client-screen" element={<PrivateRoute><ClientScreen/></PrivateRoute>}/>
                    <Route path="/protected/my-results" element={<PrivateRoute><MyResults/></PrivateRoute>}/>
                </Routes>
            </Router>
        </AuthProvider>
    );
}

function RequireAuth({ children }) {
    const auth = useAuth();
    return auth.isAuthenticated ? children : <Navigate to="/login" />;
}

export default App;
